import { SxProps, Theme } from '@mui/material';

export const breadcrumbTrailContainerSX: SxProps<Theme> = (theme) => ({
	// '--contentSpacing': theme.dimensions.contentSpacing,
	marginLeft: { xs: -1, sm: -1 },
	marginTop: { xs: 2, sm: 3 },
	// marginBottom: 'calc((0 - var(--contentSpacing)) * .25rem)',
	fontFamily: 'GT-America-Condensed, GT-America, Roboto, sans-serif',
	textTransform: 'uppercase',
	color: 'secondary.dark',

	'& > ol > li > a': {
		minWidth: 'auto',
	},

	'& > ol > .MuiBreadcrumbs-li:not(:has(> a))': {
		display: 'inline-block',
		paddingX: 1,
	},
});

export const breadcrumbTrailLinkableSX: SxProps<Theme> = (theme) => ({
	color: theme.palette.secondary.dark,
	fontFamily: 'GT-America-Condensed, GT-America, Roboto, sans-serif',
	textTransform: 'uppercase',
	padding: 1,
});
